export default __webpack_public_path__ + "static/media/Fabrication-Vendors.a2be545a.jpg";